import Entity from '../entity'

export default class Claim extends Entity<number>{
    type_id: number;
    state_id: number;
    source_id: number;
    dealer_id: number;
    manufacturer_id: number;
    code: string;
    customer_name: string;
    customer_phone: string;
    customer_email: string;
    model: string;
    version: string;
    plate: string;
    vin: string;
    year: number;
    km: number;
    details: string;
    solution: string;
    satisfied: boolean;
    complaint_type_id: number;
    agreement_id: number;
    close_days: number;
    comments: string;
    employees: Array<string>;
    emails: Array<string>;
}